/* eslint-disable @typescript-eslint/no-unused-vars */
import { AxiosError } from "axios";

import useApi from "../api";
import { ISignInResponse } from "./interfaces/ISignInResponse";
import { ISignIn } from "./interfaces/ISignIn";
import { IApiResponse } from "../interfaces/IApiResponse";
import { useFormatMessage } from "../../utils/useFormatMessage";
import { ISignUp } from "./interfaces/ISignUp";
import { IUser } from "../user/interfaces/IUser";
import { IAuth } from "./interfaces/IAuth";

export const useAuthService = () => {
  const api = useApi();
  const { errorMessage } = useFormatMessage();

 async function signIn(
  model: ISignIn
): Promise<IApiResponse<any>> {
  try {
    const response = await api.post("/Auth/token", model);
    return { status: response.status, data: response.data };
  } catch (error: AxiosError | any) {
    if (error.code === "ERR_NETWORK") {
      return {
        status: 503,
        data: errorMessage("ERR_NETWORK"),
      };
    }
    return {
      status: error.response?.status || 500,
      data: errorMessage(error.response?.data || error.message),
    };
  }
}

async function getAuth(): Promise<IApiResponse<IAuth[] | any>> {
  try {
    const response = await api.get("/Auth/me"); 
    return { status: response.status, data: response.data };
  } catch (error: AxiosError | any) {
    if (error.code === "ERR_NETWORK") {
      return {
        status: 503,
        data: errorMessage("ERR_NETWORK"),
      };
    }
    return {
      status: error.response?.status || 500,
      data: errorMessage(error.response?.data || error.message),
    };
  }
}

  async function signUp(model: ISignUp): Promise<IApiResponse<IUser | any>> {
    try {
      const response = await api.post("/Auth/SignUp", model);
      return { status: response.status, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }

  return {
    getAuth,
    signIn,
    signUp,
  };
};
